// extracted by mini-css-extract-plugin
module.exports = {"profilePage":"ProfilePage_profilePage__21adJ","profileBlock":"ProfilePage_profileBlock__2u5RN"};